/* src/app/components/sidebar/hero/hero.component.scss */
* {
  margin: 0;
  padding: 0;
}
#hero {
  display: grid;
  grid-template-columns: auto 1fr;
  color: var(--ion-color-primary);
  padding: 0.5rem 1rem;
  gap: 1rem;
  place-items: center;
  border-bottom: 1px solid #e2e2e2;
}
#hero img {
  --size: 50px;
  border-radius: 50%;
  width: var(--size);
  height: var(--size);
  object-fit: cover;
}
#hero .text {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
}
#hero .text h2 {
  font-size: 20px;
  font-weight: bold;
}
#hero .text .info {
  display: grid;
  grid-template-columns: auto 1fr;
  place-items: center;
  gap: 0.75rem;
  margin-top: 5px;
}
#hero .text .info div {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  font-size: 14px;
}
#hero .text .info:first-child {
  margin-top: 0;
}
/*# sourceMappingURL=hero.component.css.map */
